import { PayloadAction } from '@reduxjs/toolkit';
import * as ActionType from '../actions/multipleQuotesAction';

export interface contentfulState {
    multipleQuotes: {
        ids?: string[];
        compareQuotes?: any[];
        currentId?: string;
        versionId?: string;
    };
}
const initialState: contentfulState = {
    multipleQuotes: {},
};
export const multipleQuotesReducer = (
    state = initialState,
    action: PayloadAction<any>,
) => {
    switch (action.type) {
        case ActionType.SET_MULTIPLE_QUOTES:
            return {
                multipleQuotes: action.payload,
            };
        case ActionType.UPDATE_MULTIPLE_QUOTES:
            return {
                ...state,
                multipleQuotes: { ...state.multipleQuotes, ...action.payload },
            };
        default:
            return state;
    }
};
